export const SUBMIT_SUPPORT_FORM = 'GIFTYA/SUBMIT_SUPPORT_FORM';
export const submitSupportForm = (payload, meta = {}, error = false) => ({
    type: SUBMIT_SUPPORT_FORM,
    payload,
    meta,
    error
});

export const SUBMIT_SUPPORT_FORM_RESET = 'GIFTYA/SUBMIT_SUPPORT_FORM_RESET';
export const submitSupportFormReset = (payload, meta, error) => ({
    type: SUBMIT_SUPPORT_FORM_RESET,
    payload,
    meta,
    error
});